/**
 * In-memory token storage for cross-origin auth.
 * When frontend and API are on different domains, cookies are blocked.
 * We store tokens from login/register/refresh responses and send them in requests.
 */
let accessToken: string | null = null;
let refreshToken: string | null = null;

export function setTokens(access: string, refresh: string): void {
  accessToken = access;
  refreshToken = refresh;
}

export function getAccessToken(): string | null {
  return accessToken;
}

export function getRefreshToken(): string | null {
  return refreshToken;
}

export function clearTokens(): void {
  accessToken = null;
  refreshToken = null;
}

export function hasTokens(): boolean {
  return !!(accessToken && refreshToken);
}
